import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserTypeEnum } from 'src/app/services/common/constant.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UserProfileComponent } from 'src/app/shared/widgets/user-profile/user-profile.component';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {
  isLoggedIn: any = false;
  loginUserName: any = "";
  isPWA = window.matchMedia('(display-mode: standalone)').matches;
  isDelegate = false;

  @Input() isHideToggleButton = false;
  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();

  constructor(private _router: Router,
    public dialog: MatDialog,
    private _userInfoService: UserInfoService,
    private _storageService: StorageService) { }

  ngOnInit(): void {
    this.isLoggedIn = this._userInfoService.getLoginFlag();
    this._storageService.loginSubject.subscribe(message => {
      this.isLoggedIn = this._userInfoService.getLoginFlag();
    });
    let userInfo = this._userInfoService.getUserInfo();
    this.loginUserName = this.buildGreeting(userInfo);
    this.isDelegate = userInfo.delegateAccess;
    this._storageService.pwaInstallSubject.subscribe(message => {
      this.isPWA = true;
      this.isHideToggleButton = true;
    });

    if (this.isPWA)
      this.isHideToggleButton = true;
  }

  toggleSideBar() {
    this.toggleSideBarForMe.emit();
    setTimeout(() => {
      window.dispatchEvent(
        new Event('resize')
      );
    }, 300);
  }

  private buildGreeting(userInfo: any): string {
    const firstName = userInfo?.firstName ?? '';
    const lastName = userInfo?.lastName ?? '';
    const fullName = `${firstName} ${lastName}`.trim();
    const types: string[] = userInfo?.userType ?? [];

    if (types.includes(UserTypeEnum.CP)) {
      return `CP ${firstName}`.trim();
    }
    if (types.includes(UserTypeEnum.VP)) {
      return `VP ${firstName}`.trim();
    }
    if (types.includes(UserTypeEnum.DIRECTOR)) {
      return `Director ${firstName}`.trim();
    }
    if (types.includes(UserTypeEnum.PARTNER)) {
      return `Partner ${firstName}`.trim();
    }

    return fullName;
  }

  onClickUserProfile() {
    let dialogRef = this.dialog.open(UserProfileComponent, {
      disableClose: true,
      width: '100%',
      minHeight: '560px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  logout() {
    this._storageService.loginSubject.next(false);
    this._userInfoService.logout();
  }
}
